<header class="header anonymous">
  <sc-placeholder
    name="ab-header"
    [rendering]="rendering"
    class="header-container"
  ></sc-placeholder>
</header>
